export enum HtmlTestTypes {
  checkbox = 'checkbox',
  button = 'button',
  input = 'input',
  link = 'link',
  radio = 'radio',
  block = 'block',
}

export function getTestId(name: string, type: HtmlTestTypes): string {
  return `${name}_${type}`
}
